import service from '@/utils/axios-v2'
import axios from 'axios'

export function getDocListByTrack(id) {
  return service({
    url: `/fleet/file_folder/get/trip/web/files?tripId=${id}`,
    method: 'get',
    headers: {
      'no-common-token': true
    }
  })
}

export function getDriverInfo(id, cancelToken) {
  return service({
    url: `/fleet/driver/trip/driver/info/get?tripId=${id}`,
    method: 'get',
    headers: {
      'no-common-token': true
    },
    cancelToken
  })
}

export function shreTripBindDriver(id) {
  return service({
    url: `/fleet/driver/trip/driver/bind?tripId=${id}`,
    method: 'get',
    headers: {
      'no-common-token': true
    },
  })
}


export function inviteDriver(id) {
  return service({
    url: `/fleet/driver/trip/driver/invite?tripId=${id}`,
    method: 'get',
    headers: {
      'no-common-token': true
    }
  })
}

export function delDoc(params) {
  return service({
    url: `/fleet/file_folder/delete/trip/web/files`,
    method: 'post',
    data: params,
    headers: {
      'no-common-token': true
    }
  })
}

export function addDoc(params) {
  return service({
    url: `/fleet/file_folder/add/trip/web/files`,
    method: 'post',
    data: params,
    headers: {
      'no-common-token': true
    }
  })
}

export function sendCheck(params) {
  return service({
    url: `/fleet/file_folder/trip/web/check/sendV2`,
    method: 'post',
    data: params,
    headers: {
      'no-common-token': true
    }
  })
}

export function getShareInfo(data, cancelToken) {
  return service({
    baseURL: process.env.VUE_APP_TP_URL,
    url: '/truckerpath-routing/trip/share/info',
    method: 'post',
    data,
    headers: {
      'tp-interface': true,
      'no-common-token': true
    },
    cancelToken
  })
}

export function getSharedTrips() {
  return service({
    url: '/fleet/route/trip/list?size=100&page=0',
    method: 'get',
    headers: {
      'portal-token': true,
      'no-common-token': true
    }
  })
}


export function sendMessage(data) {
  return service({
    url: '/fleet/share-trip/message/send',
    method: 'post',
    headers: {
      'portal-token': true,
      'no-common-token': true
    },
    data: data
  })
}

export function listMessage(shareId, params) {
  return service({
    url: `/fleet/share-trip/message/history/${shareId}`,
    method: 'get',
    headers: {
      'portal-token': true,
      'no-common-token': true
    },
    data: params
  })
}


export function getTrip(url, cancelToken) {
  return axios.get(url, { cancelToken })
}

export function upload(params) {
  return service({
    url: '/fleet/trip_share/trip/upload/push/send',
    params,
    method: 'get',
    isNotPrompt: true
  })
}
